'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { Record } from 'immutable';
export const LinkedInAdTypes = {
  TEXT_AD: 'TEXT_AD',
  SPONSORED_STATUS_UPDATE: 'SPONSORED_STATUS_UPDATE',
  SPONSORED_INMAILS: 'SPONSORED_INMAILS',
  SPONSORED_VIDEO: 'SPONSORED_VIDEO',
  FOLLOW_COMPANY_V2: 'FOLLOW_COMPANY_V2',
  SPOTLIGHT_V2: 'SPOTLIGHT_V2',
  JOBS_V2: 'JOBS_V2'
};
export default class LinkedInAdRecord extends Record({
  accountId: null,
  campaignId: null,
  adGroupId: null,
  id: null,
  network: null,
  name: null,
  formId: null,
  status: null,
  previousState: null,
  type: null,
  imageUrl: null,
  body: null,
  headline: null,
  cta: null,
  websiteUrl: null
}) {
  constructor(_ref) {
    let {
      networkAdType
    } = _ref,
        props = _objectWithoutPropertiesLoose(_ref, ["networkAdType"]);

    super(Object.assign({}, props, {
      type: networkAdType
    }));
  }

}